export interface PerioAnchorRect {
  toothId: number
  left: number
  top: number
  width: number
  height: number
}

export interface PerioConnectorBox {
  width: number
  height: number
}

const RECT_MOVE_PX = 0.5

const moved = (previous: number, next: number): boolean =>
  Math.abs(previous - next) >= RECT_MOVE_PX

export const perioAnchorsMoved = (
  previous: PerioAnchorRect[],
  next: PerioAnchorRect[],
): boolean => {
  if (previous.length !== next.length) {
    return true
  }
  for (let index = 0; index < previous.length; index += 1) {
    const before = previous[index]
    const after = next[index]
    if (
      before.toothId !== after.toothId ||
      moved(before.left, after.left) ||
      moved(before.top, after.top) ||
      moved(before.width, after.width) ||
      moved(before.height, after.height)
    ) {
      return true
    }
  }
  return false
}

export const perioBoxMoved = (
  previous: PerioConnectorBox,
  next: PerioConnectorBox,
): boolean =>
  moved(previous.width, next.width) || moved(previous.height, next.height)

/** One query for the row, then rects in tooth order. */
export const readPerioRowAnchors = (
  container: HTMLElement,
  toothIds: readonly number[],
  part: string,
): PerioAnchorRect[] => {
  const containerRect = container.getBoundingClientRect()
  const byKey = new Map<string, HTMLElement>()
  container
    .querySelectorAll<HTMLElement>(`[data-perio-anchor$="-${part}"]`)
    .forEach((element) => {
      const key = element.getAttribute('data-perio-anchor')
      if (key) {
        byKey.set(key, element)
      }
    })
  const anchors: PerioAnchorRect[] = []
  for (const toothId of toothIds) {
    const element = byKey.get(`${toothId}-${part}`)
    if (!element) {
      continue
    }
    const rect = element.getBoundingClientRect()
    if (rect.width <= 0 || rect.height <= 0) {
      continue
    }
    anchors.push({
      toothId,
      left: rect.left - containerRect.left,
      top: rect.top - containerRect.top,
      width: rect.width,
      height: rect.height,
    })
  }
  return anchors
}
